<script>
	import { createEventDispatcher } from "svelte";
	import {
		Button,
		Modal,
		ModalBody,
		ModalFooter,
		ModalHeader,
	} from "@sveltestrap/sveltestrap";

	export let isOpen = false;
	export let workOrder = null;

	const dispatch = createEventDispatcher();

	let setVehicleActive = true;

	$: if (isOpen) {
		setVehicleActive = true;
	}

	function close() {
		dispatch("close");
	}

	function confirm() {
		dispatch("confirm", {
			setVehicleActive:
				workOrder?.flowType === "Workshop"
					? setVehicleActive
					: undefined,
		});
	}
</script>

<Modal {isOpen} toggle={close} centered>
	<ModalHeader toggle={close}>Mark as completed?</ModalHeader>
	<ModalBody>
		<p class="my-2 mb-4">This work order will be marked as completed.</p>
		{#if workOrder?.flowType === "Workshop"}
			<p class="mb-2">Set this vehicle as active?</p>
			<div class="form-check my-2">
				<input
					class="form-check-input"
					type="radio"
					name="setVehicleActive"
					id="set-vehicle-active-yes"
					value={true}
					bind:group={setVehicleActive}
				/>
				<label class="form-check-label" for="set-vehicle-active-yes">
					Yes
				</label>
			</div>
			<div class="form-check">
				<input
					class="form-check-input"
					type="radio"
					name="setVehicleActive"
					id="set-vehicle-active-no"
					value={false}
					bind:group={setVehicleActive}
				/>
				<label class="form-check-label" for="set-vehicle-active-no">
					No
				</label>
			</div>
		{:else}
			<p class="mb-0">The vehicle will remain locked.</p>
		{/if}
	</ModalBody>
	<ModalFooter>
		<Button class="themeButton backButton" on:click={close}>Cancel</Button>
		<Button class="themeButton primary" on:click={confirm}>Confirm</Button>
	</ModalFooter>
</Modal>
